/**
 * Supported device types for the app experience split.
 */
export type DeviceType = 'mobile' | 'desktop';

export const DEVICE_MOBILE: DeviceType = 'mobile';
export const DEVICE_DESKTOP: DeviceType = 'desktop';

/**
 * Detects whether the current device should receive the mobile or desktop experience.
 *
 * Priority:
 * 1. URL query param override (?view=mobile or ?view=desktop)
 * 2. User-agent sniffing for mobile devices
 * 3. Viewport width check (≤768px = mobile)
 */
export function detectDevice(): DeviceType {
  const override = new URLSearchParams(window.location.search).get('view');
  if (override === DEVICE_MOBILE || override === DEVICE_DESKTOP) return override;

  const uaMobile = /Android|iPhone|iPod/i.test(navigator.userAgent);
  const narrowViewport = window.matchMedia('(max-width: 768px)').matches;
  return uaMobile || narrowViewport ? DEVICE_MOBILE : DEVICE_DESKTOP;
}
